import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import { Lineitem } from '../../interfaces/Ordel.Interface';
import AssociateJobModal from './AssociateJobModal';

export interface AssociatedJobFieldProps {
	value: Lineitem | null;
	onChange: (job: Lineitem | null) => void;
	disabled?: boolean;
	placeholder?: string;
	style?: React.CSSProperties;
	productionMethodFilter?: string;
	autoOpen?: boolean;
	status?: 'error';
}

const AssociatedJobField: React.FC<AssociatedJobFieldProps> = ({
	value,
	onChange,
	disabled = false,
	placeholder = 'Select Job',
	style,
	productionMethodFilter,
	autoOpen = false,
	status,
}) => {
	const [modalOpen, setModalOpen] = useState(false);

	useEffect(() => {
		if (autoOpen) {
			setModalOpen(true);
		}
	}, [autoOpen]);

	const handleAssociate = (job: Lineitem) => {
		onChange(job);
		setModalOpen(false);
	};

	return (
		<>
			<div style={{ display: 'flex', gap: 8, ...style }}>
				{value ? (
					<Button
						type="dashed"
						onClick={() => setModalOpen(true)}
						style={{ width: '100%', textAlign: 'left', overflow: 'hidden' }}
						icon={<EditOutlined />}
						disabled={disabled}
						danger={status === 'error'}
					>
						{value.name || ''}
					</Button>
				) : (
					<Button
						type="dashed"
						onClick={() => setModalOpen(true)}
						style={{ width: '100%' }}
						icon={<SearchOutlined />}
						disabled={disabled}
						danger={status === 'error'}
					>
						{placeholder}
					</Button>
				)}
			</div>
			<AssociateJobModal
				visible={modalOpen}
				onClose={() => setModalOpen(false)}
				onAssociate={handleAssociate}
				defaultJob={value}
				defaultProductionMethod={productionMethodFilter}
			/>
		</>
	);
};

export default AssociatedJobField;
